// extracted by mini-css-extract-plugin
module.exports = {"new":"index_new_3Wv4q","favorite":"index_favorite_CFgGP","thumb":"index_thumb_2SGlZ","image":"index_image_3jJot"};